import { ILevelDataFile } from '../System/Level/Data/ILevelDataFile';
import { getEpisodeIndex } from './LevelHelper';
import Game from '../Game';
import { GameActions } from '../State/Game/GameActions';

function init() {
    if (!window.WebSocket) return;

   // const socket = new window.WebSocket('ws://localhost:3125');
   // socket.addEventListener('message', handleMessage);
   // socket.addEventListener('error', (e) => console.log(e));

    function handleMessage(event: any): void {
        const data = JSON.parse(event.data);

        switch (data.type) {
            case 'PlayLevel': {
                const TEST_LEVEL_NUMBER = 99;
                const key = `levelData_${TEST_LEVEL_NUMBER}`;
                const level: ILevelDataFile = data.level;
                const episodeIndex = Math.max(3, getEpisodeIndex(level.settings));
                level.settings.background = `episode_${episodeIndex}.jpg`;
                Game.resource.cacheResource(key, level);

                GameActions.loadLevel({
                    levelNumber: TEST_LEVEL_NUMBER,
                    preBoosters: data.preBoosters || [],
                    isLevelTest: true,
                });
            }
        }
    }
}

init();
